import axios from 'axios';

function getAuthHeaders() {
    const token = localStorage.getItem('userToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchSourceUrl(id, { signal } = {}) {
    const response = await axios.post(
        `${import.meta.env.VITE_BASE_URL}/api/jewelry/${id}/source`,
        {},
        { headers: getAuthHeaders(), signal },
    );

    return response.data;
}

export async function fetchHousePasses({ signal } = {}) {
    const response = await axios.get(
        `${import.meta.env.VITE_BASE_URL}/api/house-passes`,
        { headers: getAuthHeaders(), signal },
    );

    return response.data;
}

export function formatHousePassResetLabel(resetsAt) {
    if (!resetsAt) {
        return null;
    }

    const date = new Date(resetsAt);
    if (Number.isNaN(date.getTime())) {
        return null;
    }

    const formatted = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
    }).format(date);

    return `Resets ${formatted}`;
}
